<template>
  <v-container v-if="department" fluid>
    <Title :src="department.src" :text="department.name" />
    <v-row
      v-for="category in department.sub_categories"
      :key="category.category_id"
      class="background-color-white mb-6 mr-sm-0 px-6"
    >
      <v-col>
        <v-row align="center" class="mr-sm-0" justify="space-between">
          <v-col>
            <div class="font-size-lg">{{ category.category_name }}</div>
          </v-col>
          <v-col class="text-right">
            <router-link
              class="d-flex justify-end"
              :to="{
                name: 'category',
                params: { categoryId: category.category_id },
              }"
            >
              View more {{ category.category_name }}
              <v-icon color="primary">mdi-chevron-right</v-icon>
            </router-link>
          </v-col>
        </v-row>
        <v-row>
          <v-col
            v-for="product in adjustProductsLengthForBreakpoint(
              category.products
            )"
            class="position-relative"
            :key="product.upc"
            cols="12"
            sm="6"
            md="3"
            xl="2"
          >
            <Product :product="product" :size="'md'" />
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Product from "@/components/Product/index.vue";
import Title from "@/components/UI/Title.vue";

export default {
  name: "Department",
  components: { Product, Title },
  methods: {
    adjustProductsLengthForBreakpoint(products) {
      // 4 products are returned form API which fills an xl row (default)
      const end = {
        sm: 2,
        md: 4,
        lg: 4,
        xl: 6,
      };
      return products.slice(0, end[this.$vuetify.breakpoint.name]) || products;
    },
  },
  props: { department: Object },
};
</script>
